/**
 * HUB.SMSRoute.Api
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { PlatformServiceDto } from '../model/platformServiceDto';
import { PlatformServiceModel } from '../model/platformServiceModel';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class PlatformResourcesService {

    protected basePath = '/';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * 
     * @param id 
     * @param serviceId 
     * @param serviceName 
     * @param systemName 
     * @param owner 
     * @param ownerId 
     * @param countryCodeIso 
     * @param countryCode 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiPlatformResourcesDetailGet(id?: string, serviceId?: string, serviceName?: string, systemName?: string, owner?: string, ownerId?: string, countryCodeIso?: string, countryCode?: string, observe?: 'body', reportProgress?: boolean): Observable<PlatformServiceModel>;
    public apiPlatformResourcesDetailGet(id?: string, serviceId?: string, serviceName?: string, systemName?: string, owner?: string, ownerId?: string, countryCodeIso?: string, countryCode?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<PlatformServiceModel>>;
    public apiPlatformResourcesDetailGet(id?: string, serviceId?: string, serviceName?: string, systemName?: string, owner?: string, ownerId?: string, countryCodeIso?: string, countryCode?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<PlatformServiceModel>>;
    public apiPlatformResourcesDetailGet(id?: string, serviceId?: string, serviceName?: string, systemName?: string, owner?: string, ownerId?: string, countryCodeIso?: string, countryCode?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {









        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (id !== undefined && id !== null) {
            queryParameters = queryParameters.set('id', <any>id);
        }
        if (serviceId !== undefined && serviceId !== null) {
            queryParameters = queryParameters.set('serviceId', <any>serviceId);
        }
        if (serviceName !== undefined && serviceName !== null) {
            queryParameters = queryParameters.set('serviceName', <any>serviceName);
        }
        if (systemName !== undefined && systemName !== null) {
            queryParameters = queryParameters.set('systemName', <any>systemName);
        }
        if (owner !== undefined && owner !== null) {
            queryParameters = queryParameters.set('owner', <any>owner);
        }
        if (ownerId !== undefined && ownerId !== null) {
            queryParameters = queryParameters.set('ownerId', <any>ownerId);
        }
        if (countryCodeIso !== undefined && countryCodeIso !== null) {
            queryParameters = queryParameters.set('countryCodeIso', <any>countryCodeIso);
        }
        if (countryCode !== undefined && countryCode !== null) {
            queryParameters = queryParameters.set('countryCode', <any>countryCode);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<PlatformServiceModel>('get',`${this.basePath}/api/PlatformResources/detail`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param serviceId 
     * @param serviceName 
     * @param systemName 
     * @param owner 
     * @param ownerId 
     * @param countryCodeIso 
     * @param countryCode 
     * @param startFrom 
     * @param take 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiPlatformResourcesDetailsGet(serviceId?: string, serviceName?: string, systemName?: string, owner?: string, ownerId?: string, countryCodeIso?: string, countryCode?: string, startFrom?: number, take?: number, observe?: 'body', reportProgress?: boolean): Observable<PlatformServiceDto>;
    public apiPlatformResourcesDetailsGet(serviceId?: string, serviceName?: string, systemName?: string, owner?: string, ownerId?: string, countryCodeIso?: string, countryCode?: string, startFrom?: number, take?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<PlatformServiceDto>>;
    public apiPlatformResourcesDetailsGet(serviceId?: string, serviceName?: string, systemName?: string, owner?: string, ownerId?: string, countryCodeIso?: string, countryCode?: string, startFrom?: number, take?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<PlatformServiceDto>>;
    public apiPlatformResourcesDetailsGet(serviceId?: string, serviceName?: string, systemName?: string, owner?: string, ownerId?: string, countryCodeIso?: string, countryCode?: string, startFrom?: number, take?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {










        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (serviceId !== undefined && serviceId !== null) {
            queryParameters = queryParameters.set('serviceId', <any>serviceId);
        }
        if (serviceName !== undefined && serviceName !== null) {
            queryParameters = queryParameters.set('serviceName', <any>serviceName);
        }
        if (systemName !== undefined && systemName !== null) {
            queryParameters = queryParameters.set('systemName', <any>systemName);
        }
        if (owner !== undefined && owner !== null) {
            queryParameters = queryParameters.set('owner', <any>owner);
        }
        if (ownerId !== undefined && ownerId !== null) {
            queryParameters = queryParameters.set('ownerId', <any>ownerId);
        }
        if (countryCodeIso !== undefined && countryCodeIso !== null) {
            queryParameters = queryParameters.set('countryCodeIso', <any>countryCodeIso);
        }
        if (countryCode !== undefined && countryCode !== null) {
            queryParameters = queryParameters.set('countryCode', <any>countryCode);
        }
        if (startFrom !== undefined && startFrom !== null) {
            queryParameters = queryParameters.set('startFrom', <any>startFrom);
        }
        if (take !== undefined && take !== null) {
            queryParameters = queryParameters.set('take', <any>take);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<PlatformServiceDto>('get',`${this.basePath}/api/PlatformResources/details`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
